module.exports = __webpack_public_path__ + "img/package-active.064035c6.png";